import {getTotalsForTheMonth, getTotalThirdPartyOrdersByWeek} from "../Util/dataHelper";

export class CredentialsObj {
    constructor(email, pass) {
        this.email = email;
        this.pass = pass;
    }
}

export class SelectedPageComponent {
    constructor(component) {
        this.component = component
    }
}

export class PartnerDetailsObj {
    constructor(id, partnerType, address, billingAddress, billingDiscountAmount, companyName, contactPerson, contactPersonTitle, email, phoneNo, partnerCode) {
        this.id = id;
        this.partnerType = partnerType;
        this.address = address;
        this.billingAddress = billingAddress;
        this.billingDiscountAmount = billingDiscountAmount;
        this.companyName = companyName;
        this.contactPerson = contactPerson;
        this.contactPersonTitle = contactPersonTitle;
        this.email = email;
        this.phoneNo = phoneNo;
        this.partnerCode = partnerCode;
    }

    getDiscountAmount() {
        return this.billingDiscountAmount;
    }

    getAdminNameAndEmail() {
        return [this.contactPerson, this.email];
    }

    isPremiumPartner() {
        return this.partnerType === "PREMIUM";
    }

    isPremiumOrResellerPartner(){
        return this.partnerType === 'PREMIUM' || this.partnerType === 'RESELLER';
    }
}

export class PartnerAccountsObject {
    constructor(arr) {
        this.accountsArrRaw = arr;
        this.accountsArrFormatted = [];
        this.accountsObj = {};
        this.totalPaidAccounts = 0;
        this.constructAccountObjects();
    }

    constructAccountObjects() {
        this.accountsArrRaw.forEach((account) => {
            account.memberSince = account.memberSince || "N/A";
            account.memberSince = account.memberSince.split(" ")[0];
            let accountObj = new PartnerAccountObject(account.companyId, account.dispatcherId, account.companyName, account.dispatcherName, account.email, account.phone, account.country, account.currentPlan, account.memberSince, account.paidAccount)
            this.accountsObj[account.companyId] = accountObj;
            this.accountsArrFormatted.push(accountObj);
            if (accountObj.paidAccount) this.totalPaidAccounts++;
        })
    }

    getAccountsArray() {
        return this.accountsArrFormatted;
    }

    getAccountsObj() {
        return this.accountsObj;
    }

    getAccountDetailsByCompanyId(companyId) {
        return this.accountsObj[companyId];
    }

    getTotalCountOfActiveAccounts() {
        return this.accountsArrFormatted.length;
    }

    getTotalCountOfPaidAccounts() {
        return this.totalPaidAccounts;
    }
}

export class PartnerAccountObject {
    constructor(companyId, dispatcherId, companyName, adminName, email, phoneNumber, country, currentPlan, memberSince, paidAccount) {
        this.companyId = companyId;
        this.dispatcherId = dispatcherId;
        this.companyName = companyName;
        this.adminName = adminName;
        this.email = email;
        this.phoneNumber = phoneNumber;
        this.country = country;
        this.currentPlanRaw = currentPlan;
        this.memberSince = memberSince;
        this.paidAccount = paidAccount;
    }
}

export class PartnerBillingDetailsObject {
    constructor(billingArr) {
        this.billingArr = billingArr;
        this.billingFormattedObj = {};
        this.constructBillingFormattedObj();
    }

    constructBillingFormattedObj() {
        this.billingArr.forEach((billingInfoByDate) => {
            let totalsInfo = getTotalsForTheMonth(billingInfoByDate.billingInfos);
            billingInfoByDate = Object.assign(billingInfoByDate, totalsInfo)
            this.billingFormattedObj[billingInfoByDate.date] = billingInfoByDate;
        })
    }

    getBillingInfoByDate(date) {
        return this.billingFormattedObj[date];
    }
}

class PartnerSingleInvoiceObj {
    constructor(chargeId, customerId, totalAmountPaid, invoiceUrl, chargeTimeInSec, currency, isSuccessful) {
        this.chargeId = chargeId;
        this.customerId = customerId;
        this.totalAmountPaid = Number(Number(totalAmountPaid) / 100).toFixed(2);
        this.invoiceUrl = invoiceUrl;
        this.chargeTime = Number(chargeTimeInSec) * 1000;
        this.currency = currency;
        this.isSuccessful = isSuccessful;
    }
}

export class PartnerInvoicesObject {
    constructor(invoicesArr) {
        this.partnerInvoicesArr = [];
        this.constructPartnerInvoicesArr(invoicesArr);
    }

    constructPartnerInvoicesArr(invoicesArr) {
        this.partnerInvoicesArr = invoicesArr.map((invoice) => {
            return new PartnerSingleInvoiceObj(invoice.chargeId, invoice.customerId, invoice.totalAmountPaid, invoice.invoiceUrl, invoice.chargeTime, invoice.currency, invoice.isSuccessful)
        })
    }

    getInvoicesArr() {
        return this.partnerInvoicesArr;
    }
}

export class PartnerCreditCardDetailsObject {
    constructor(last4Digits, expireMonth, expireYear) {
        this.last4Digits = last4Digits;
        this.expireMonth = expireMonth;
        this.expireYear = expireYear;
    }
}

export class PartnerBankInfo {
    constructor(name, routing, acc, firstName, lastName, email) {
        this.name = name;
        this.routing = routing;
        this.acc = acc;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
    }
}

export class PartnerThirdPartyBillingDetailsObject {
    constructor(weeklyBillingArr) {
        this.rawWeeklyBillingArr = weeklyBillingArr;
        this.weeklyBillingFormattedObj = {};
        this.constructWeeklyBillingFormattedObj();
    }

    constructWeeklyBillingFormattedObj() {
        this.rawWeeklyBillingArr.forEach((billingInfoByWeek) => {
            let totalsInfo = getTotalThirdPartyOrdersByWeek(billingInfoByWeek.billingInfos);
            billingInfoByWeek = Object.assign(billingInfoByWeek, totalsInfo)
            if (totalsInfo.billedAccountsCount != 0) {
                this.weeklyBillingFormattedObj[billingInfoByWeek.week] = billingInfoByWeek;
            }
        })
    }

    getBillingInfoByDate(date) {
        return this.weeklyBillingFormattedObj[date];
    }
}

export class AccountMagicLink {
    constructor(magicLink) {
        this.magicLink = magicLink;
    }

    getMagicLink() {
        return this.magicLink;
    }
}

export class ACHBankInfo {
    constructor(bankName, last4Digits, routingNo, email, customerId) {
        this.bankName = bankName;
        this.last4Digits = last4Digits;
        this.routingNo = routingNo;
        this.email = email;
        this.customerId = customerId;
    }
}

export class ClientSecret {
    constructor(secret) {
        this.secret = secret;
    }

    getSecret() {
        return this.secret;
    }
}

export class PayoutBankInfo {
    constructor(
        stripeAccountId,
        actorId,
        actorType,
        connectStatus,
        stripeEmail,
        accountNumber,
        routingNumber,
        accountHolder,
        ipAddress
    ) {
        this.stripeAccountId = stripeAccountId;
        this.actorId = actorId;
        this.actorType = actorType;
        this.connectStatus = connectStatus;
        this.stripeEmail = stripeEmail;
        this.accountNumber = accountNumber;
        this.routingNumber = routingNumber;
        this.accountHolder = accountHolder;
        this.ipAddress = ipAddress;
    }
}

export class PaypalApprovalLink {
    constructor(link) {
        this.link = link;
    }

    getLink() {
        return this.link;
    }
}

export class PaypalInfo {
    constructor(accId, email, customerId, confirmedAt) {
        this.accountId = accId;
        this.email = email;
        this.customerId = customerId;
        this.confirmedAt = confirmedAt;
    }

    getEmail() {
        return this.email;
    }
}

export class PaypalIdentity {
    constructor(email, accId, name, confirmedAt, verified) {
        this.email = email;
        this.accountId = accId;
        this.name = name;
        this.confirmedAt = confirmedAt;
        this.verified = verified;
    }

    getMaskedEmail() {
        const atInd = this.email.indexOf('@');
        const prefix = this.email.substr(0, atInd);
        return prefix[0] + "*****" + prefix[prefix.length-1] + this.email.substr(atInd);
    }

    getName() {
        return this.name;
    }

    isVerified() {
        return this.verified;
    }
}

export class LastMonthBilling {
    constructor(billingId, paid) {
        this.billingId = billingId;
        this.paid = paid;
    }

    isPaid() {
        return this.paid;
    }
}

export class PlansList {
    _flavourConfigs = {
        BUSINESS_ADVANCED: {
            name: "Business Advanced",
            paid: true,
            order: 1,
        },
        BRANDED_ELITE: {
            name: "Branded Elite",
            paid: true,
            order: 2,
        },
        BRANDED_LEGACY: {
            name: "Branded Premium",
            paid: true,
            order: 3,
        },
        BRANDED_PREMIUM: {
            name: "Branded Premium",
            paid: true,
            order: 3,
        },
        PROFESSIONAL: {
            name: "Professional",
            paid: true,
            order: 4,
        },
        TRIAL: {
            name: "Trial (Professional)",
            paid: false,
            order: 5,
        },
        STARTER: {
            name: "Starter",
            paid: false,
            order: 6,
        },
    }

    static getPlanNames() {
        return Object.entries(this._flavourConfigs).map(([key, value]) => value.name);
    }

    constructor(data) {
        this.flavourMapping = data.reduce((mapping, plan) => {
            mapping[plan.planName] = {
                flavour: plan.flavour,
                hasSms: plan.hasSms,
            };
            return mapping;
        }, {});
    }

    isPlanNameValid(planName) {
        return planName in this.flavourMapping;
    }

    isPaid(planName) {
        if (planName in this.flavourMapping) {
            const {flavour} = this.flavourMapping[planName];
            return this._flavourConfigs?.[flavour]?.paid ?? false;
        } else {
            return false;
        }
    }

    getDisplayName(planName) {
        if (planName in this.flavourMapping) {
            const {flavour, hasSms} = this.flavourMapping[planName];
            if (flavour in this._flavourConfigs) {
                return this._flavourConfigs[flavour].name + (!hasSms && flavour !== "STARTER" ? " (without sms)" : "");
            } else {
                return planName;
            }
        } else {
            return "Unknown";
        }
    }

    getOrderKey(planName) {
        if (planName in this.flavourMapping) {
            const {flavour, hasSms} = this.flavourMapping[planName];
            return [this._flavourConfigs[flavour].order, hasSms ? 0 : 1];
        } else {
            return [9999, 9999];
        }
    }
}
